var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40192 1.5C8.55663 -0.500001 11.4434 -0.5 12.5981 1.5L18.6603 12C19.815 14 18.3716 16.5 16.0622 16.5H3.93782C1.62842 16.5 0.185045 14 1.33975 12L7.40192 1.5Z",
    fill: "url(#paint0_linear_1_854)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_854",
    x1: 10,
    y1: -3,
    x2: 10,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMark);
export default __webpack_public_path__ + "static/media/SelectedMark.bb41fb79d47f89223f4a459618a35265.svg";
export { ForwardRef as ReactComponent };